const productFields = ['commercialCode', 'images(FULL)', 'name', 'url', 'externalLogistician'];

const orderEntryFields = [
  `product(${productFields.join(',')})`,
  'entryNumber',
  'basePrice(formattedValue)',
  'totalPriceWithoutDiscounts(formattedValue,value)',
  'totalPrice(formattedValue,value)'
];

const consignmentEntryFields = [`orderEntry(${orderEntryFields.join(',')})`, 'quantity', 'shippedQuantity'];

export const orderReturnFields = [
  'code',
  `entries(${consignmentEntryFields.join(',')})`,
  'returnDocument',
  'returnTicket'
];
